export const WHATSAPP_NUMBER = '553184470080';
export const INSTAGRAM_URL =
    'https://www.instagram.com/tatiene.librelon?utm_source=ig_web_button_share_sheet&exln=ZDNlZDc0MzIxNw==';
export const MAPS_URL = 'https://maps.app.goo.gl/XR1jhqRRyF16VwA7A';
export const CURSO_URL = 'https://go.hotmart.com/C108174443S?dp=1';

export const getWhatsappUrl = (mensagem: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;
